// 参加者の個別保存（PATCH）で送る内容。支払い状態は従来の正規化ルールで求め、
// 読み込んだ時点（open.payment）から変わったときだけ送る（API は未指定なら支払い状態を変えない）。
export function buildEntryPatch(open, draft) {
  const hadPayment = open.payment === "paid" || open.payment === "refunded";
  let payment = draft.payment;
  if (draft.tab === "attend") {
    payment = draft.payment === "paid" ? "paid" : "unpaid";
  } else if (draft.tab === "absent") {
    payment = hadPayment ? (draft.payment === "refunded" ? "refunded" : "paid") : "unpaid";
  }
  const patch = {
    participation: draft.tab,
    program_ids: draft.tab === "attend" ? draft.classKeys : [],
    absent_reason: draft.tab === "absent" ? draft.absentReason : "",
  };
  return payment !== open.payment ? { ...patch, payment_status: payment } : patch;
}

// 一括更新の対象＝選択中かつ画面に見えている行（検索で隠れた行は含めない）
export const visibleSelection = (selected, rows) => {
  const visible = new Set(rows.map((r) => r.id));
  return selected.filter((id) => visible.has(id));
};
